import template from './template'
import templates from './templates'

export default {
    template,
    templates,
}
